import { trade_in_statuses } from "../components/SellNow/config";

const initialState = {
    suggested_item: null,
    trade_in_savings: null,
    show_trade_in_spinner: false,
    trade_status: trade_in_statuses.IN_PROGRESS
}

export default function tradeInReducer(state=initialState, action) {
    switch (action.type) {
        case 'TRADE_STARTED':
            return {
                ...state,
                trade_status: trade_in_statuses.IN_PROGRESS
            }
        case 'TRADE_ADDED_TO_CART':
            return {
                ...state,
                trade_status: trade_in_statuses.SUCCESS
            }
        case 'SHOW_TRADE_SPINNER':
            return {
                ...state,
                show_trade_in_spinner: true
            }
        case 'HIDE_TRADE_SPINNER':
            return {
                ...state,
                show_trade_in_spinner: false
            }
        case 'TRADE_IN_SUGGESTION':
            return {
                ...state,
                suggested_item: action.suggested_item
            }
        case 'TRADE_IN_SAVINGS':
            return {
                ...state,
                trade_in_savings: action.trade_in_savings
            }
        default:
            return state;
    }
};